import { Injectable } from '@angular/core';
import {
    HttpClient,
    HttpHeaders,
    HttpErrorResponse,
    HttpParams,
} from "@angular/common/http";
import { Observable, throwError, of } from "rxjs";
import { map, catchError } from "rxjs/operators";
import { SearchRequest } from '../models/organization-model';
import { AppConfig } from "../design/app";
import { IAppConfig } from '../core/models/app-config.model';
import { IApiResponse } from '../core/models/api-response.model';
import { CompaniesDTO } from '../shared/models/companies.model';

const urlsStartPoint = "";

@Injectable({
  providedIn: 'root'
})
export class CreateClientService {
    public appConfig: any;
    searchParameters : SearchRequest;

    constructor(private http: HttpClient) {

      this.appConfig = AppConfig;
     }
    
    public getAllCompanyData(requestBody: SearchRequest): Observable<CompaniesDTO[]> {
        const baseUrl = this.appConfig.organization.baseUrl;
        const getCompaniesList = this.appConfig.organization.getCompaniesList;
        const apiUrl: string = `${baseUrl + getCompaniesList}`;
        const headers = new HttpHeaders();
      
        return this.http.post<IApiResponse<CompaniesDTO[]>>(apiUrl, requestBody, { headers: headers }).pipe(
            map((res) => res.Data),
            catchError(this.handleError)
        );
    }

    public verifyCompany(inputData: any): Observable<any> {
        const baseUrl = this.appConfig.organization.baseUrl;
        const verifyCompany = this.appConfig.organization.verifyCompany;
        const apiUrl: string = `${baseUrl + verifyCompany}`;
        return this.http.post<IApiResponse<any>>(apiUrl, inputData).pipe(
            map((res) => {
                if (res) {
                    return res.Data;
                }
                return null;
            })
        );
    }
    
    public saveData(inputData: any): Observable<CompaniesDTO> {
        const baseUrl = this.appConfig.organization.baseUrl;
        const saveCompanyDetails = this.appConfig.organization.saveCompanyDetails;
        const apiUrl: string = `${baseUrl + saveCompanyDetails}`;
        return this.http.post<IApiResponse<CompaniesDTO>>(apiUrl, inputData).pipe(
            map((res) => res.Data),
            catchError(this.handleError)
        );
    }

    private handleError(error: HttpErrorResponse) {
        if (error.error instanceof ErrorEvent) {
            console.error("An error occurred:", error.error.message);
        } else {
            console.error(
                `Backend returned code ${error.status}, ` + `body was: ${error.error}`
            );
        }
        return throwError("Something bad happened; please try again later.");
    }
}
